import { Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { OnboardingRedirectGuard } from '@guards/onboarding-redirect.guard';

/**
 * TRACK ROUTES
 * User speciality comparison and tracking routes
 *
 */
export const TRACK_ROUTES: Routes = [
  {
    path: 'speciality/:speciality_uuid/user/:user_uuid',
    loadComponent: () =>
      import(
        '@modules/track/components/speciality/track-speciality-user-compare/track-speciality-user-compare.component'
      ).then(m => m.TrackSpecialityUserCompareComponent),
    data: { roles: ['user'] },
    canActivate: [AuthGuard, OnboardingRedirectGuard],
  },
];
